import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import SearchHotelPrefsForm from './SearchHotelPrefsForm';

class SearchHotelPrefsModal extends React.Component {
  constructor(props) {
    super(props);
  }

  saveSearchPrefs = (pref) => {
    sessionStorage.removeItem("prefs");
    sessionStorage.setItem("prefs", JSON.stringify(pref));
    this.props.handleSearch()
  }
  render() {
     // Getting saved prefs from session storage
     let savedPrefs = JSON.parse(sessionStorage.getItem('prefs'));
     if(savedPrefs == undefined) {
      savedPrefs = {'brands': [], 'stars': { lower: 0, upper: 6 }}
     }
     const searchPrefs = (
        <SearchHotelPrefsForm
          brandList={this.props.brandList}
          brandGroups={this.props.brandGroups}
          savedPrefs={savedPrefs}
          saveSearchPrefs={this.saveSearchPrefs}
          onClose={this.props.onClose}
        />
        )

    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Hotel Search Preferences</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="bid-panel-big" id="searchPreferPopup">
              <div className="group-info">
                <h4 className="search-prefer-instruction-header">Find the Right Hotel!</h4>
                <p className="search-prefer-instruction-text">
                  To narrow down your search and help you filter out things you don’t want to see, use the options below to set search preferences.
                </p>
                {searchPrefs}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    );
  }
}

SearchHotelPrefsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SearchHotelPrefsModal;



// WEBPACK FOOTER //
// src/routes/hotels/components/SearchHotelPrefsModal.js